import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FaBed, FaPhoneAlt, FaDollarSign, FaMapMarkerAlt, FaAddressCard } from "react-icons/fa";

const API_BASE = process.env.REACT_APP_API_URL + "/api";

export default function ListingDetail() {
    const { id } = useParams();

    const [listing, setListing] = useState(null);
    const [loading, setLoading] = useState(true);
    const [mainImage, setMainImage] = useState(null);

    useEffect(() => {
        async function load() {
            const res = await fetch(`${API_BASE}/listings/${id}`);
            const data = await res.json();

            setListing(data);
            setMainImage(data.imageUrl);
            setLoading(false);
        }

        load();
    }, [id]);

    if (loading) return <p>Loading listing...</p>;
    if (!listing) return <p>Listing not found</p>;

    const images = listing.images || [listing.imageUrl];

    return (
        <div className="details-page">

            {/* HERO IMAGE */}
            <div className="hero">
                <img
                    src={mainImage || "/placeholder.png"}
                    alt={listing.title}
                />
            </div>

            <div className="details-content">

                {/* MAIN INFO */}
                <div className="main-info">

                    <h1 className="detail-title">{listing.title}</h1>

                    {/* PRICE */}
                    <div className="price">
                        <span className="starting">Starting at</span>
                        <FaDollarSign />{Number(listing.base_price || 0).toLocaleString()}
                        <span className="per-month"> / month</span>
                    </div>

                    <p className="location">
                        <FaAddressCard /> {listing.address}, {listing.city}, {listing.state} {listing.zip}
                    </p>

                    <div className="stats">
                        <span><FaBed /> {listing.bedrooms || "N/A"} Beds</span>
                        <span><FaPhoneAlt /> {listing.phone || "Contact for info"}</span>
                    </div>

                    {/* DESCRIPTION */}
                    <section className="description">
                        <h2>About this home</h2>
                        <p>
                            {listing.description ||
                                "Comfortable adult family home offering personalized care in a safe and welcoming environment."}
                        </p>
                    </section>

                    {/* IMAGE GALLERY */}
                    <section className="gallery">
                        <h2>Photos</h2>

                        <div className="gallery-strip">
                            {images.map((img, i) => (
                                <img
                                    key={i}
                                    src={img}
                                    alt=""
                                    onClick={() => setMainImage(img)}
                                />
                            ))}
                        </div>
                    </section>
                </div>

                {/* RIGHT SIDE — INQUIRY PANEL */}
                <aside className="inquiry-panel">

                    <h3>Request Information</h3>

                    <form
                        onSubmit={async (e) => {
                            e.preventDefault();

                            const form = new FormData(e.target);

                            await fetch(`${API_BASE}/inquiries`, {
                                method: "POST",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify({
                                    listingId: Number(id),
                                    name: form.get("name"),
                                    email: form.get("email"),
                                    message: form.get("message"),
                                }),
                            });

                            alert("Inquiry sent!");
                            e.target.reset();
                        }}
                    >
                        <input name="name" placeholder="Your name" required />
                        <input name="email" type="email" placeholder="Email" required />
                        <textarea
                            name="message"
                            placeholder="I'm interested in this home..."
                            required
                        />
                        <button type="submit">Send Inquiry</button>
                    </form>
                </aside>

            </div>

            {/* MAP SECTION */}
            <section className="map-section">
                <div className="map-card">
                    <div className="map-header">
                        <h3><FaMapMarkerAlt /> Location</h3>
                        <span className="map-address">
                            {listing.address}, {listing.city}, {listing.state} {listing.zip}
                        </span>
                    </div>

                    <div className="map-wrapper">
                        <iframe
                            title="listing-map"
                            loading="lazy"
                            allowFullScreen
                            src={`https://www.google.com/maps?q=${encodeURIComponent(
                                `${listing.address}, ${listing.city}, ${listing.state} ${listing.zip}`
                            )}&output=embed`}
                        />
                    </div>
                </div>
            </section>

        </div>
    );
}